import { Injectable } from '@angular/core'
import Cookies from 'js-cookie'
import { COOKIE_STORAGE_SETTINGS } from './cookie-storage-settings'

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  getGlobal<T>(storageKey: string): T | undefined {
    const result = Cookies.get(storageKey)
    if (result === 'undefined' || result === 'null') {
      return undefined
    }
    return result as T
  }

  setGlobal(storageKey: string, data: any): void {
    const cookieAttributes = COOKIE_STORAGE_SETTINGS as Cookies.CookieAttributes
    if (data !== undefined && data !== null) {
      Cookies.set(storageKey, data, cookieAttributes)
    } else {
      Cookies.remove(storageKey, cookieAttributes)
    }
  }

  removeGlobal(storageKey: string): void {
    const cookieAttributes = COOKIE_STORAGE_SETTINGS as Cookies.CookieAttributes
    Cookies.remove(storageKey, cookieAttributes)
  }
}
